<template>
    <component v-if="itemDefinition" v-bind:is="itemDefinition.viewType" v-bind:itemDefinition="itemDefinition"></component>
</template>

<script>
    import PlotList from "./automated/PlotList";
    import {mapGetters} from 'vuex'

    export default {
        name: 'Automated',
        components: {PlotList},
        computed: {
            ...mapGetters([
                'automatedViewsConfig',
            ]),
            itemDefinition() {
                return this.automatedViewsConfig[this.$route.params.id]
            },
        }
    }
</script>
